import React from "react";
import { Link } from "react-router-dom";
import {
  formatNumber,
  Heart,
  ShoppingCartIcon,
  substring,
  withProductContainer,
} from "../normalizer";
import CustomButton from "./CustomButton";
import { t } from "i18next";

const ableToBuy = (canBuy) => {
  if (canBuy !== undefined)
    return canBuy
  return true
}

const ProductCard = ({
  colors,
  product,
  onFavAddition,
  onFavRemove,
  onCartAdd,
  canBuy,
  currencyLabel,
  tight,
  className,
  ...campaignProduct
}) => {
  const { is_favorite, points, id } = campaignProduct;
  const limitedName = substring(product.name, 35, "...");
  const currencyLabelFinal =
    currencyLabel || localStorage.getItem("currency") || "pts";

  return (
    <div className={`product-card ${className} ${id ? "with-actions" : ""} ${tight ? "tight" : ""} `}>
      <div className="product-card-image-container">
        {id ? (
          <Link to={`/catalog/product/${id}`}>
            <img src={product.main_image.url} alt={product.name} />
          </Link>
        ) : (
          <img src={product.main_image.url} alt={product.name} />
        )}
      </div>
      <div className={`product-card-info-container ${tight ? "tight" : ""} ${id ? "with-actions" : ""}`}>
        <div className={`product-card-info-title ${id ? "with-actions" : ""}`}>{limitedName}</div>
        <div className="product-card-info-points">
          <span className="product-card-info-points-container-points">
            {formatNumber(points)}
          </span>
          <span className="product-card-info-points-container-currency">
            {currencyLabelFinal}
          </span>
        </div>
        {id ? <div className="product-card-info-filler"></div> : null}
        {id ? (
          <div className="product-card-info-actions">
            {ableToBuy(canBuy) ? (
              <CustomButton
                className="product-card-info-actions-add"
                tight
                link
                onClick={onCartAdd}
              >
                <ShoppingCartIcon />
                Adicionar
              </CustomButton>
            ) : (
              <div></div>
            )}

            <CustomButton
              link
              small
              tight
              className={`product-card-info-actions-fav ${
                is_favorite ? "fav" : ""
              }`}
              onClick={is_favorite ? onFavRemove : onFavAddition}
            >
              <Heart />
            </CustomButton>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default withProductContainer(ProductCard);
